import { SlingoEvent } from "@lib/titan2-slingo/dist/game/controller/event/SlingoEvent";
import { Ticket } from "@lib/titan2-slingo/dist/game/view/abstract/display/Ticket";
import { DialogEvent } from "@lib/titan2/dist/game/manager/DialogManager";
/**
 * GameTicket.ts
 */
export class GameTicket extends Ticket {
    addEventListeners() {
        super.addEventListeners();
        this.unregisterGame(SlingoEvent.SLINGO);
        this.registerGame(SlingoEvent.SLINGO_TICKET_ANIMATION, this.handleSlingo);
    }
    handleSlingoComplete() {
        this.dispatchGame(SlingoEvent.SLINGO_TICKET_ANIMATION_COMPLETE);
    }
    handleDabActive() {
        super.handleDabActive();
        if (this.factory.getDialogManager().isDialogOpen()) {
            // If a dialog is open, wait for it to close before handling the symbol hint.
            this.registerGame(DialogEvent.INACTIVE, function handleDialogInactive() {
                this.unregisterGame(DialogEvent.INACTIVE, handleDialogInactive);
                this.handleSymbolHint();
            });
        }
        else {
            // If no dialog is open, handle the symbol hint immediately.
            this.handleSymbolHint();
        }
    }
    async handleSymbolHint() {
        const symbolHint = this.model.getSymbolHint();
        const hintedSymbol = this.symbolsByNumber.getValue(symbolHint);
        if (hintedSymbol) {
            await new Promise(resolve => this.callAfter(this.model.getAutoDabInterval(), resolve));
            hintedSymbol.select();
        }
    }
}
//# sourceMappingURL=GameTicket.js.map